/* Scoped announcement: no customer data, dependencies, or storage. */
if (!customElements.get('hg-fall-announcement')) {
  customElements.define('hg-fall-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.checkWindow = () => {
        clearTimeout(this.expiryTimer);
        const now = Date.now();
        const start = Date.parse(this.dataset.starts);
        const end = Date.parse(this.dataset.ends);
        if (!Number.isFinite(start) || !Number.isFinite(end) || now < start || now >= end) {
          this.expire();
          return;
        }
        this.expiryTimer = setTimeout(this.checkWindow, Math.min(end - now, 2147483647));
      };
      this.checkWindow();
      if (!this.isConnected) return;
      this.setAttribute('data-ready', '');
      const toggle = this.querySelector('button');
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        toggle.setAttribute('aria-label', paused ? toggle.dataset.resume : toggle.dataset.pause);
      });
      this.fillTrack = () => {
        if (!this.isConnected) return;
        const link = this.querySelector('.hg-fall-announcement__link');
        const groups = [...this.querySelectorAll('.hg-fall-announcement__group')];
        const unit = groups[0].firstElementChild;
        const width = unit.getBoundingClientRect().width;
        if (!width || !link.clientWidth) return;
        const copies = Math.max(1, Math.ceil(link.clientWidth / width));
        if (groups[0].childElementCount !== copies) {
          groups.forEach(group => group.replaceChildren(
            ...Array.from({length: copies}, () => unit.cloneNode(true))
          ));
        }
        this.style.setProperty('--hg-fall-duration', (copies * width / 35) + 's');
      };
      this.fillTrack();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.fillTrack);
        this.resizeObserver.observe(this.querySelector('.hg-fall-announcement__link'));
      }
      window.addEventListener('resize', this.fillTrack);
      document.fonts?.ready.then(this.fillTrack);
      document.addEventListener('visibilitychange', this.checkWindow);
      window.addEventListener('pageshow', this.checkWindow);
    }
    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.fillTrack);
      document.removeEventListener('visibilitychange', this.checkWindow);
      window.removeEventListener('pageshow', this.checkWindow);
    }
    expire() {
      const fallback = document.createElement('div');
      fallback.className = 'hg-v12-announcement';
      fallback.append(this.querySelector('template').content.cloneNode(true));
      this.replaceWith(fallback);
    }
  });
}
